import { Component, Input, OnInit, ChangeDetectionStrategy, inject, input, output } from '@angular/core';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { Icons } from '../../../util/Icons';
import { SessionService } from '../../../services/session.service';
import { AraEditorComponent } from '../../util/ara-editor/ara-editor.component';

@Component({
	selector: 'ara-uvi-letter',
	templateUrl: './uvi-letter.component.html',
	styleUrls: ['./uvi-letter.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslocoDirective, AraEditorComponent],
})
export class UviLetterComponent implements OnInit {
	translocoService = inject(TranslocoService);
	sessionService = inject(SessionService);
	icons = inject(Icons);

	public model = {
		text: '',
	};

	readonly editable = input(false);

	@Input() exampleText: string;
	readonly disabled = input(false);
	readonly coverTextChange = output<string>();
	public selectedLang: string;
	private currentCoverText: string;

	get coverText(): string {
		return this.currentCoverText;
	}

	@Input() set coverText(newText: string) {
		this.currentCoverText = newText;
		this.coverTextChange.emit(newText);
	}

	ngOnInit(): void {
		switch (this.translocoService.getActiveLang()) {
			case 'de':
				this.selectedLang = 'german';
				break;
			case 'en':
				this.selectedLang = 'english';
				break;
		}
		if (!this.exampleText) {
			this.exampleText = this.translocoService.translate('settings.coverExampleText');
		}
	}
}
